/**
 * Shared utility for filtering internal/system-generated emails.
 * Internal emails use domains like @auth.behtari.internal or @behtari.pk
 * and should never be displayed to users.
 */

export function isInternalEmail(email: string): boolean {
  if (!email) return true;
  return email.includes('behtari.internal') || email.includes('behtari.pk');
}

export function getDisplayEmail(profile?: { email?: string | null; auth_email?: string | null }): string {
  const email = profile?.email || profile?.auth_email || '';
  return email && !isInternalEmail(email) ? email : '';
}
